module.exports = __webpack_public_path__ + "img/cupRight.de611d7a.png";